import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Card,
  Col,
  Row,
  Modal,
  message,
  Select,
  notification,
  Tabs,
  Tooltip,
} from "antd";
import Button from "../../../shared/globalStyling/Button";
import { PlusOutlined } from "@ant-design/icons";
import { cardMargin, cardBody } from "../../../shared/globalStyling/style";
import LocationListView from "./LocationListView";
import MapDrawing from "../../../shared/maps/MapDrawing";
import { stateList } from "../../../../core/utils/constants/constants";
import CreateAudienceForm from "./CreateAudienceForm";
import source from "../../../../assets/maps/demo-retail-location.gif";
import DrawingToolsDemoPopup from "../../../shared/maps/DrawingToolsDemoPopup";
import LocationAttributionAudiences from "./LocationAttributionAudiences";

const { Option } = Select;

const LocationTab = ({
  locationList,
  parentState,
  changeLocationMap,
  onChange,
  createLocation,
  deleteLocation,
  editRetailLocation,
  resetParentState,
  updateOrgLocation,
  cartProvider,
  onChangeStateValue,
  selectedLocations,
  onSubmitAudience,
  attributionAudienceName,
  shouldClearShapes,
  toggleShouldClearShapes,
  selectedOrgId,
  attributionAudiences,
  currentuser,
}) => {
  //Location
  const getCartProvider =
    cartProvider &&
    cartProvider.__type &&
    cartProvider.__type.enumValues &&
    cartProvider.__type.enumValues;

  const {
    id,
    name,
    street,
    city,
    zip,
    state,
    description,
    email,
    contact,
    url,
    phone,
    selectedGeoTargets,
    cart,
    menuDataKey,
    lat,
    start,
    end,
    attributionWindow,
    locationKey,
  } = parentState || {};

  const [formShow, setFormShow] = useState(false);
  const [form] = Form.useForm();
  useEffect(() =>
    form.setFieldsValue({
      name: name,
      description: description,
      street: street,
      city: city,
      state: state,
      zip: zip,
      email: email,
      contact: contact,
      url: url,
      cart: cart ? cart : "Select Cart",
      menuDataKey: menuDataKey,
      locationKey: locationKey,
      phone: phone,
      start: start,
      end: end,
      attributionWindow: attributionWindow,
    })
  );

  const [initialLocation, setInitialLocation] = useState({
    latitude: "37.774929",
    longitude: "-122.419418",
  });

  const [isAudienceModalVisible, setIsAudienceModalVisible] = useState(false);

  const [audienceType, setAudienceType] = useState("");

  const toggleForm = val => {
    setFormShow(val);
    if (!val) {
      setInitialLocation({ latitude: "37.774929", longitude: "-122.419418" });
    }
  };

  const onCreateNewRetailLocation = e => {
    toggleForm(false);
    createLocation();
    message.loading("Action in progress..", 0);
  };

  const onDeleteRetailLocation = Id => {
    toggleForm(false);

    message.loading("Action in progress..", 0);

    deleteLocation(Id)
      .then(() => {
        message.destroy();
        message.success(`Successfully deleted retail Location`);
      })
      .catch(err => {
        message.destroy();
        message.error(`Error: Cannot delete retail Location`);
      });
  };

  const onEditRetailLocation = data => {
    toggleForm(false);
    resetParentState();

    setTimeout(() => {
      setInitialLocation({ latitude: data.lat, longitude: data.lng });
      editRetailLocation(data);
      toggleForm(true);
    }, 100);
  };

  const onCloseForm = () => {
    toggleForm(false);
    resetParentState();
  };

  const onCreateLocation = () => {
    toggleForm(true);
    resetParentState();
  };

  const onUpdateOrgLocation = () => {
    toggleForm(false);

    updateOrgLocation()
      .then(() => {
        message.destroy();
        message.success(`Successfully updated retail Location`);
      })
      .catch(err => {
        message.destroy();
        message.error(`Error: Cannot update retail Location`);
      });
  };

  const handleChange = value => {
    onChange(["cart"], value);
  };

  const onFinish = () => {
    if (lat === null) {
      message.error(
        `On the Map Please Search and Click on the Retail Location Address you want to Save!`
      );
      return false;
    }
    id === "" ? onCreateNewRetailLocation() : onUpdateOrgLocation();
  };

  const handleAttributionAudience = async () => {
    setIsAudienceModalVisible(false);
    onSubmitAudience(audienceType);
  };

  const onCloseAudienceForm = () => {
    setIsAudienceModalVisible(false);
  };

  const { TabPane } = Tabs;

  return (
    <>
      <Tabs type="card" defaultActiveKey="location">
        <TabPane
          tab={
            <Tooltip
              title={
                "Have the ability to add specific locations to target for your advertising or marketing efforts. This includes creating custom audiences based on these locations, and managing your location data through the import and export of CSV files. You can also download a sample template as a guide. Additionally, you have the ability to delete any location from your targeting locations list as per your preference."
              }
            >
              <span>Addresses</span>
            </Tooltip>
          }
          key="location"
        >
          {formShow && (
            <Modal
              visible={formShow}
              title="Edit Retail Location"
              onOk={onFinish}
              onCancel={onCloseForm}
              width={1500}
              footer={null}
            >
              <Row gutter={18} style={{ position: "relative" }}>
                <Col xs={24} lg={12}>
                  <Card style={{ ...cardMargin }}>
                    <div>
                      <DrawingToolsDemoPopup
                        style={{
                          position: "absolute",
                          right: 0,
                          left: 460,
                          margin: "auto",
                          top: 80,
                        }}
                        source={source}
                        feature="Retail Target Locations"
                      />
                    </div>
                    <MapDrawing
                      inputPlaceholder={"Search Retail Location..."}
                      zoom={5}
                      shapes={selectedGeoTargets}
                      overlayChanged={val => {
                        onChange("inProgressOverlay", val);
                      }}
                      initialLocation={initialLocation}
                      shouldClearShapes={shouldClearShapes}
                      clearedCallback={toggleShouldClearShapes}
                      toolOptions={{
                        fillColor: "#BCDCF9",
                        fillOpacity: 0.5,
                        strokeWeight: 3,
                        strokeColor: "#57ACF9",
                        clickable: true,
                        editable: true,
                        zIndex: 1,
                      }}
                      styles={{
                        map: {
                          height: "940px",
                          width: "100%",
                          position: "absolute",
                          top: 0,
                          left: 0,
                        },
                        mapContainer: {
                          height: "950px",
                          width: "100%",
                          position: "relative",
                        },
                      }}
                      changeLocation={place => {
                        changeLocationMap(place);
                      }}
                      drawing={true}
                    />
                  </Card>
                </Col>

                <Col xs={24} lg={12}>
                  <Card
                    style={{ ...cardMargin }}
                    title={
                      id === ""
                        ? "Create New Retail Location"
                        : "Edit Retail Location"
                    }
                    extra={
                      <Button
                        type="primary"
                        onClick={() => {
                          onChangeStateValue("refreshGeotargetDates", true);

                          notification.open({
                            message: "Successfully Refreshed Geotargets Dates!",
                          });
                        }}
                      >
                        Refresh Geotarget Dates
                      </Button>
                    }
                  >
                    <Form
                      name=""
                      form={form}
                      layout="vertical"
                      onFinish={onFinish}
                      autoComplete="off"
                      initialValues={{
                        name: name,
                        description: description,
                        street: street,
                        city: city,
                        state: state,
                        zip: zip,
                        email: email,
                        contact: contact,
                        url: url,
                        cart: cart ? cart : "Select Cart",
                        menuDataKey: menuDataKey,
                        phone: phone,
                        locationKey: locationKey,
                      }}
                    >
                      <Form.Item
                        label="Business name"
                        name="name"
                        rules={[
                          {
                            required: true,
                            message: "Please input your Business name!",
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter Business Name"
                          name="name"
                          onChange={({ target }) => {
                            onChange([target.name], target.value);
                          }}
                        />
                      </Form.Item>
                      <Form.Item label="About" name="description">
                        <Input
                          placeholder="Enter Business Description"
                          name="description"
                          onChange={({ target }) => {
                            onChange([target.name], target.value);
                          }}
                        />
                      </Form.Item>
                      <Form.Item label="Address" name="street">
                        <Input
                          placeholder="Address"
                          name="street"
                          onChange={({ target }) => {
                            onChange([target.name], target.value);
                          }}
                        />
                      </Form.Item>
                      <Row>
                        <Col xs={24} xl={9} style={{ padding: 5 }}>
                          <Form.Item
                            help="Check / Verify and Edit the - City - "
                            label="City"
                            name="city"
                            rules={[
                              {
                                required: true,
                                message: "Please input your City!",
                              },
                            ]}
                            wrapperCol={{ span: 24 }}
                          >
                            <Input
                              placeholder="City"
                              name="city"
                              onChange={({ target }) => {
                                onChange([target.name], target.value);
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} xl={9} style={{ padding: 5 }}>
                          <Form.Item
                            help=" - State -  "
                            label="State"
                            name="state"
                            rules={[
                              {
                                required: true,
                                message: "Please input your State!",
                              },
                            ]}
                            wrapperCol={{ span: 24 }}
                          >
                            <Select
                              showSearch
                              placeholder="Select State"
                              name="state"
                              style={{ width: "100%", borderRadius: "0px" }}
                              onChange={value => {
                                onChange("state", value);
                              }}
                            >
                              {stateList.map(item => (
                                <Select.Option key={item} value={item}>
                                  {item.replace("_", " ")}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} xl={6} style={{ padding: 5 }}>
                          <Form.Item
                            help=" - Zip -  "
                            label="Zip"
                            name="zip"
                            rules={[
                              {
                                required: true,
                                message: "Please input your Zip!",
                              },
                            ]}
                            wrapperCol={{ span: 24 }}
                          >
                            <Input
                              placeholder="Zip"
                              name="zip"
                              onChange={({ target }) => {
                                onChange([target.name], target.value);
                              }}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col style={{ padding: 5 }} xs={24} xl={12}>
                          <Form.Item
                            label="Email"
                            name="email"
                            wrapperCol={{ span: 24 }}
                            rules={[
                              {
                                type: "email",
                                message: "Please enter a valid email address",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Email"
                              name="email"
                              onChange={({ target }) => {
                                onChange([target.name], target.value);
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col style={{ padding: 5 }} xs={24} xl={12}>
                          <Form.Item
                            label="Point of Contact"
                            name="contact"
                            wrapperCol={{ span: 24 }}
                          >
                            <Input
                              placeholder="Contact"
                              name="contact"
                              onChange={({ target }) => {
                                onChange([target.name], target.value);
                              }}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Form.Item label="Phone Number" name="phone">
                        <Input
                          placeholder="Phone"
                          type="number"
                          name="phone"
                          onChange={({ target }) => {
                            onChange([target.name], target.value);
                          }}
                        />
                      </Form.Item>
                      <Form.Item
                        label="Website"
                        name="url"
                        rules={[
                          {
                            type: "url",
                            message:
                              "Please enter a valid website URL in the format https://website.com",
                          },
                        ]}
                      >
                        <Input
                          placeholder="Website URL"
                          name="url"
                          onChange={({ target }) => {
                            onChange([target.name], target.value);
                          }}
                        />
                      </Form.Item>
                      <Row>
                        <Col style={{ padding: 5 }} xs={24} xl={12}>
                          <Form.Item label="Cart" name="cart">
                            <Select
                              style={{ width: "100%", borderRadius: 0 }}
                              name="cart"
                              onChange={handleChange}
                            >
                              {getCartProvider &&
                                getCartProvider.map(val => {
                                  const { name } = val;
                                  return (
                                    <Option key={name} value={name}>
                                      {name}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col style={{ padding: 5 }} xs={24} xl={12}>
                          <Form.Item label="Menu Data Key" name="menuDataKey">
                            <Input
                              placeholder="Menu Data Key"
                              name="menuDataKey"
                              onChange={({ target }) => {
                                onChange([target.name], target.value);
                              }}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col style={{ padding: 5 }} xs={24} xl={12}>
                          <Form.Item label="Location Key" name="locationKey">
                            <Input
                              placeholder="Location Key"
                              name="locationKey"
                              onChange={({ target }) => {
                                onChange([target.name], target.value);
                              }}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Form.Item
                        help={
                          lat === null
                            ? "`On the Map Please Search and Click on the Retail Location Address you want to Save!`"
                            : ""
                        }
                      >
                        <Button
                          type="primary"
                          htmlType="submit"
                          disabled={lat === null}
                        >
                          Submit
                        </Button>
                        <Button
                          type="primary"
                          onClick={() => onCloseForm()}
                          ghost="true"
                        >
                          Cancel
                        </Button>
                      </Form.Item>
                    </Form>
                  </Card>
                </Col>
              </Row>
            </Modal>
          )}
          <Row gutter={[18, 18]}>
            <Col xs={24} lg={24}>
              <Card
                style={cardMargin}
                bodyStyle={cardBody}
                title="Locations"
                extra={
                  !formShow ? (
                    <>
                      <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => onCreateLocation()}
                      >
                        Add Retail Locations
                      </Button>
                      <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        disabled={
                          selectedLocations && selectedLocations.length === 0
                        }
                        onClick={() => {
                          setAudienceType("ATTRIBUTION");
                          setIsAudienceModalVisible(true);
                        }}
                      >
                        Create Attribution Audiences
                      </Button>
                    </>
                  ) : null
                }
              >
                <LocationListView
                  locationList={locationList}
                  deleteLocation={onDeleteRetailLocation}
                  editRetailLocation={onEditRetailLocation}
                  onChangeStateValue={onChangeStateValue}
                  selectedOrgId={selectedOrgId}
                  attributionAudiences={attributionAudiences}
                />
              </Card>
            </Col>
          </Row>
          {isAudienceModalVisible && (
            <CreateAudienceForm
              attributionAudienceName={attributionAudienceName}
              isFormOpen={isAudienceModalVisible}
              closeForm={onCloseAudienceForm}
              onChangeStateValue={onChangeStateValue}
              submitForm={handleAttributionAudience}
            />
          )}
        </TabPane>
        <TabPane
          tab={
            <Tooltip
              title={
                "The ability to to create an audience from a targeting location "
              }
            >
              <span>Audiences</span>
            </Tooltip>
          }
          key="audience"
        >
          <LocationAttributionAudiences
            attributionAudiences={attributionAudiences}
            currentuser={currentuser}
          />
        </TabPane>
      </Tabs>
    </>
  );
};

export default LocationTab;
